<template>
  <div class="recharge-subscript">
    <img
      src="../image/weichongzhi/icon_一键智能外呼.png"
      alt=""
      @click="outboundClick"
      ref="imgLI"
    />
    <img
      src="../image/weichongzhi/icon_AI智能助手.png"
      alt=""
      @click="chatGptClick"
    />

    <el-dialog
      title=""
      :visible.sync="dialogVisible4"
      width="50%"
      :before-close="handleClose4"
      :modal="model"
    >
      <div class="box1">欢迎拨打客服热线进行咨询</div>
      <div class="box1">{{ SettingListCC }}</div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible4 = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "felixItem",
  data() {
    return {
      SettingListCC: "",
      dialogVisible4: false,
      model: false,
    };
  },
  mounted() {
    this.SettingListCt();
  },
  methods: {
    chatGptClick() {
      this.$router.push("/chatGptS");
    },
    //一键外呼
    outboundClick() {
      this.dialogVisible4 = true;
    },
    SettingListCt() {
      let ct = sessionStorage.getItem("SettingList");
      if (ct) {
        this.SettingListCC = JSON.parse(ct).company_tel;
        this.$refs.imgLI.title = this.SettingListCC;
      } else {
        this.SettingListCC = [];
      }
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: #000;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #fff;
}
.recharge-subscript {
  width: 60px;
  height: 128px;
  background: #feffff;
  box-shadow: 0px 10px 20px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px 30px 30px 30px;
  border: 1px solid #e6e6e6;
  position: fixed;
  left: 1616px;
  top: 604px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-evenly;
  img {
    width: 36px;
    height: 36px;
    cursor: pointer;
  }
}
</style>